export default async function ({ store, redirect, params }) {
  if (!store.getters["user/IS_BAND"]) return redirect("/")
  if (!store.getters["user/favorites/BUCKET_EXISTS"](params.bucket_id))
    await store.dispatch("user/favorites/FETCH_BUCKET", params.bucket_id)
}
